import React from 'react'
import { Box, HStack, Text } from "@chakra-ui/react";
import { FormSelect } from "../FormSelect";
import { FormTextArea } from "../FormTextArea";
import { StaticUploadImage } from "../StaticUploadImage";

export const CreateInstructor = ({instructor, staffs, onChange, list}) => {
    
    return (
        <Box>
            <HStack justifyContent="space-between" alignItems="center">
                <FormSelect
                    formProps={{
                        isRequired: true,
                        maxWidth: "200px",
                    }}
                    padding="20px 0 0 0"
                    label="Instructor Name"
                    value={instructor?.InstructorName}
                    options={list?.map(s => ({ value: `${s.firstName} ${s.lastName}`, name: `${s.firstName} ${s.lastName}` }))}
                    name="InstructorName"
                    selectOnChange={onChange}
                    disabled={window.location.href.includes("updatebook")}
                />
            </HStack>
            {staffs.length === 0 ? <Text fontSize="xs">Add staff member first. Only then the names will auto populate here.</Text> : <></>}
            <StaticUploadImage
                label="Picture"
                boxSize="150px"
                labelProps={{
                    fontWeight: 600,
                    padding: "20px 0 0",
                    fontSize: "12pt"
                }}
                imageUrl={
                    instructor &&
                        instructor.InstructorPic
                        ? instructor.InstructorPic
                        : ""
                }
                maxSize={5}
                maxWidth={200}
                maxHeight={150}
                parentCallback={(file) => onChange(file, "image")}
            />
            <FormTextArea
                name="InstructorBio"
                inputName="InstructorBio"
                label="Instructor Bio"
                value={instructor?.InstructorBio}
                inputOnChange={onChange}
                padding="20px 0 0 0"
                isRequired={true}
                maxWidth="100%"
            />
        </Box>
    )
}
